module.exports = __webpack_public_path__ + "static/media/twitter.900e554c.svg";